<template>

<div>

    
    <div class="list-loader-outer">
        <transition name="loader-fade">
            <div class="list-loader" v-if="loading">
                <div class="loader"></div>
            </div>
        </transition>
    </div>

    <h1>Alla klippkort</h1>

    <div class="searchbar">

        <form>  
            
                <div class="block freetext" v-bind:class="{ active: search.text != '' && search.text != null }">
                    
                    <input class="form-control" v-on:keyup="updateQuery()" v-model="search.text" placeholder="Sök ordernr, text, antal etc" />

                </div>

                <div class="block select-medium" v-bind:class="{ active: search.product_id != null }">
                    <label>

                        <select v-model="search.product_id" v-on:change="updateQuery()">
                            <option v-bind:value="undefined">Produkt</option>
                            <option v-for="product in products" v-bind:value="product.id">{{ product.name }}</option>
                        </select>
                    </label>
                </div>

                <div class="block select-medium" v-bind:class="{ active: search.affiliate_id != null }">
                    <label>
                        <select v-model="search.affiliate_id" v-on:change="updateQuery()">
                            <option v-bind:value="undefined">Förs.kanal</option>
                            <option v-for="affiliate in affiliates" v-bind:value="affiliate.id">{{ affiliate.name }}</option>
                        </select>
                    </label>
                </div>
                <!--
                <div class="block date-from-to-container">
                    <div style="float:left; margin:7px 10px 0 0;">Skapat</div>

                    <div style="float: left; width: 100px;">
                        <datepicker language="sv" placeholder="Från" :value="date_from" v-on:selected="updateQuery(arguments[0], 'from')" :format="date_format"></datepicker>
                    </div>

                    <div style="float: left; width: 100px; margin-left:10px;">
                        <datepicker language="sv" placeholder="Till" :value="date_to" v-on:selected="updateQuery(arguments[0], 'to')" :format="date_format"></datepicker>
                    </div>
                </div>
                -->
                <!-- <div class="block" v-bind:class="{ active: search.is_manual == true }">
                    <label>
                        <input type="checkbox" v-model="search.is_manual" v-on:change="updateQuery()" /> Manuella
                    </label>
                </div> -->

                <a data-toggle="modal" data-target="#myModal" class="btn btn-sm btn-default pull-right">
                    <i class="fa fa-file" aria-hidden="true"></i> Spara excel</i>
                </a>
            
    <br clear="all">

        </form>

    </div>

</div>


</template>


<script>

    export default {
        props: {
            query: {
                required: true
            },
            loading: {}
        },
        data: function () {
            return {
                search: {},
                products: [],
                affiliates: [],
                date_format: 'yyyy-MM-dd',
                date_from: null,
                date_to: null
            }
        },
        created: function() {

            this.getOptions();

        },
        methods: {

            updateQuery: function(data, field) {

                if(field == 'from') {


                    console.log('got a from value');
                    console.log(date);

                    var date = new Date(data);
                    this.date_from = new Date(date.getFullYear(), date.getMonth(),  date.getDay())

                    this.search.from = this.date_from;
                }

                if(field == 'to') {

                    var date = new Date(data);
                    this.date_to = new Date(date.getFullYear(), date.getMonth(),  date.getDay())

                    this.search.to = this.date_to;

                }


                this.$emit('search', this.search);

            },

            getOptions: function() {

                var self = this;

                //console.log('post for options');


                this.$http.post('/cards/getOptions').then((response) => {

                    //console.log('got options');
                    //console.log(response.body);

                    self.products = response.body.products;
                    self.affiliates = response.body.affiliates;
    

                }, (response) => {
                    console.log(JSON.stringify(response))
                })


            }
        },
        watch: {
            query: function() {

                this.search = this.query;

                /*
                if(this.search.from) {
                    console.log('got a from init value');
                    console.log(this.search.from);

                    var date = new Date(this.search.from);
                    this.date_from = new Date(date.getFullYear(), date.getMonth(),  date.getDay())

                }


                if(this.search.to) {
                    console.log('got a from init value');
                    console.log(this.search.to);

                    var date = new Date(this.search.to);
                    this.date_to = new Date(date.getFullYear(), date.getMonth(),  date.getDay())
                    
                }
                */

            }
        }
    }

</script>

<style>

    .date-from-to-container .form-control {
        width:  100px;
        float:  left;
    }

</style>